<template>
  <div class="app-container" v-loading="loading">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>

      <Title>关闭依据</Title>
      <el-descriptions :column="2" border class="mt10">
        <el-descriptions-item label="关闭记录编号">{{ record.closeRecordNo || '—' }}</el-descriptions-item>
        <el-descriptions-item label="关闭时间">{{ record.closedAt || '—' }}</el-descriptions-item>
        <el-descriptions-item label="异常类型" :span="2">
          {{ (record.abnormalTypes || []).map(t => abnormalTypeText(t)).join('、') || '—' }}
        </el-descriptions-item>
        <el-descriptions-item label="反馈说明" :span="2">{{ record.feedback || '—' }}</el-descriptions-item>
      </el-descriptions>

      <Title class="mt20">系统执行结果</Title>
      <el-descriptions :column="2" border class="mt10">
        <el-descriptions-item label="账号状态变更">{{ record.customerStateClosed === false ? '未关闭' : '子账号已置为关闭' }}{{ record.entryInhibited ? '，已禁止登录' : '' }}</el-descriptions-item>
        <el-descriptions-item label="存量会话失效数">
          存量会话已失效 {{ record.sessionKickedCount != null ? record.sessionKickedCount : '—' }} 个
        </el-descriptions-item>
        <el-descriptions-item label="执行结果" :span="2">
          <el-tag :type="record.success === false ? 'danger' : 'success'">
            {{ record.success === false ? '执行失败' : '执行成功' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="失败原因" :span="2" v-if="record.success === false">
          {{ record.failReason || '—' }}
        </el-descriptions-item>
      </el-descriptions>

      <Title class="mt20">关闭操作日志</Title>
      <el-table :data="record.activities || []" class="mt10">
        <el-table-column label="操作人" prop="operatorName" align="center" />
        <el-table-column label="操作时间" prop="createdTime" align="center" />
        <el-table-column label="操作内容" prop="content" align="center" />
        <el-table-column label="结果" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.result === 2 || row.result === '失败' ? 'danger' : 'success'">
              {{ row.result === 2 || row.result === '失败' ? '失败' : '成功' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import childFollowupApi from '@/api/cust/childFollowup'

const ABNORMAL_TYPE_MAP = { 1: '本人不知情', 2: '非本人申请', 3: '资料不一致', 4: '手机号不一致', 5: '身份信息异常', 6: '申请目的异常', 7: '关系不属实', 8: '其他' }

export default {
  name: 'SubaccountFollowupCloseRecord',
  props: ['rowId'],
  data() {
    return {
      loading: false,
      record: {}
    }
  },
  created() {
    this.loadRecord()
  },
  methods: {
    loadRecord() {
      this.loading = true
      childFollowupApi.fetchCloseRecord(this.rowId)
        .then(({ data }) => { this.record = data || {} })
        .finally(() => { this.loading = false })
    },
    abnormalTypeText(v) { return ABNORMAL_TYPE_MAP[v] || v },
    handleBack() {
      this.$emit('handleShow', this.rowId, 'show')
    }
  }
}
</script>
